import { Testimonials as TestimonialsComponent } from '../components';

const Testimonials = () => {
   return <TestimonialsComponent />;
};
export default Testimonials;
